import Brands from './Brands';
import Faq from './Faq';
import GarageFeatureImageCarousel from './GarageFeatureCarousel';
import GoogleReviews from './GoogleReviews';
import HowADSCWorks from './HowADSCWorks';
import ImagesWithTitle from './ImagesWithTitle';
import ManualContent from './ManualContent';
import OfferCards from './OfferCards';
import OurFeatures from './OurFeatures';
import OurServiceCentres from './OurServiceCentres';
import Pricing from './Pricing';
import WhyAckodrive from './WhyAckodrive';
import CarServices from './carServices';
import Carousel from './carousel';
import { replaceFieldsWithValues } from './replaceFieldsWithValues';
import UserCard from './UserCard';
import Headings from './Headings';
import GarageCard from './GarageCard';
import LoginCard from './LoginCard';
import PincodeCard from './Pincode';
import {
    buttonLabels,
    garageCardHeadings,
    rewardTags,
} from './GarageCard/messages';
import { PAGE_TYPE } from '@/constants/enums';

export function SeoPages(props: any) {
    const {
        ReusableComponent,
        isBrand,
        isCity,
        isGarage,
        city,
        garage,
        brand = '',
        garageSeoManualdata = {},
        garageList = {},
        garageData = {},
        reviewData = {},
        rewardDetails = {},
        garageId,
        cardData,
        isLoggedInServerSide,
        pincode,
        userType,
        isMultipleGarage,
        pageType,
        appointmentData,
    } = props;
    const {
        componentName,
        imageUrls,
        featuresData,
        locationheading,
        nearYouheading,
        brandheading,
        servicesImages,
        locationSubText,
        nearYouSubText,
        brandSubText,
        heading,
        subText,
        stepIcon,
        steps,
        brandTitle,
        locationTitle,
        nearYouTitle,
        whyLogo,
        reasons,
        cityHeading,
        garageHeading,
        offerCards,
        showAssuranceTag,
        imagesUrl,
        logos,
        videoUrls,
        videos,
        rewardAvailableMessage,
        policyHolderDescription,
        nonPolicyHolderDescription,
        loginCardTitle,
    } = ReusableComponent;

    const { Manual, Faqs } = garageSeoManualdata;

    const location = garage ? `${garage}, ${city}` : `${city}`;
    switch (componentName) {
        // case 'ImageCarousel':
        //     return (
        //         <Carousel
        //             key="ImageCarousel"
        //             slides={[
        //                 ...videoUrls.map((url: any) => ({
        //                     ...url,
        //                     type: 'video',
        //                 })),
        //                 ...imageUrls.map((url: any) => ({
        //                     ...url,
        //                     type: 'image',
        //                 })),
        //             ]}
        //             videoLength={videoUrls?.length || 0}
        //         />
        //     );
        case 'OurFeatures':
            return <OurFeatures featuresData={featuresData} />;
        case 'CarServices':
            return (
                <CarServices
                    heading={replaceFieldsWithValues(
                        isBrand
                            ? brandheading
                            : isCity || isGarage
                              ? locationheading
                              : nearYouheading,
                        {
                            location: location,
                            brand: brand,
                            nearYou: 'near you',
                        }
                    )}
                    subText={replaceFieldsWithValues(
                        isBrand
                            ? brandSubText
                            : isCity || isGarage
                              ? locationSubText
                              : nearYouSubText,
                        {
                            location: location,
                            brand: brand,
                            nearYou: 'near you',
                        }
                    )}
                    servicesImages={servicesImages}
                    logo={garageData?.servicing_brands?.find(
                        (servicing_brand?: any) => {
                            return (
                                brand?.toLocaleLowerCase() ===
                                servicing_brand?.company_name?.toLocaleLowerCase()
                            );
                        }
                    )}
                    logos={logos}
                    cardData={cardData}
                    rewardDetails={rewardDetails}
                    rewardAvailableMessage={rewardAvailableMessage}
                    garageId={garageId}
                    isLoggedInServerSide={isLoggedInServerSide}
                    userType={userType}
                    policyHolderDescription={policyHolderDescription}
                    nonPolicyHolderDescription={nonPolicyHolderDescription}
                    pincode={pincode}
                    appointmentData={appointmentData}
                />
            );
        case 'HowADSCWorks':
            return (
                <HowADSCWorks
                    heading={heading}
                    subText={subText}
                    stepIcon={stepIcon}
                    steps={steps}
                />
            );
        case 'WhyAckodrive':
            return (
                <WhyAckodrive
                    title={replaceFieldsWithValues(
                        isBrand
                            ? brandTitle
                            : isCity || isGarage
                              ? locationTitle
                              : nearYouTitle,
                        {
                            location: location,
                            brand: brand,
                            nearYou: 'near you',
                        }
                    )}
                    subText={replaceFieldsWithValues(
                        isBrand
                            ? brandSubText
                            : isCity || isGarage
                              ? locationSubText
                              : nearYouSubText,
                        {
                            location: location,
                            brand: brand,
                            nearYou: 'near you',
                        }
                    )}
                    whyLogo={whyLogo}
                    reasons={reasons}
                />
            );
        case 'ManualContent':
            return Manual ? (
                <ManualContent
                    manualdata={Manual}
                    location={location}
                    brand={brand}
                    nearYou={'near you'}
                    city={city}
                    garage={garage}
                />
            ) : null;
        case 'Faq':
            return Faqs ? (
                <Faq
                    faqs={Faqs}
                    location={location}
                    brand={brand}
                    nearYou={'near you'}
                    city={city}
                    garage={garage}
                />
            ) : null;
        case 'OurServiceCentres':
            return (isCity || isBrand || isGarage) &&
                garageList &&
                garageList.length > 0 ? (
                <OurServiceCentres
                    heading={replaceFieldsWithValues(
                        isCity ? cityHeading : garageHeading,
                        {
                            location: location,
                            brand: brand,
                            nearYou: 'near you',
                        }
                    )}
                    garageList={garageList}
                    isCity={isCity}
                    garage={garage}
                    brand={brand}
                />
            ) : null;
        case 'OfferCards':
            return isGarage ? (
                <OfferCards heading={heading} offerCards={offerCards} />
            ) : null;
        case 'Brands':
            return garageData &&
                garageData?.servicing_brands &&
                garageData?.servicing_brands.length > 0 ? (
                <Brands
                    brandsData={garageData?.servicing_brands}
                    title={replaceFieldsWithValues(
                        isCity || isGarage ? locationTitle : nearYouTitle,
                        {
                            location: location,
                            brand: brand,
                            nearYou: 'near you',
                        }
                    )}
                    isCity={isCity}
                    garage={garage}
                    brand={brand}
                />
            ) : null;
        case 'Pricing':
            return isBrand || isGarage ? (
                <Pricing
                    garageId={props.garageId}
                    servicePricingData={props.servicePricingData}
                    packagePricingData={props.packagePricingData}
                    imageUrl={props.carImageURL}
                    makeName={props.seoMakeName}
                    modelName={props.seoModelName}
                />
            ) : null;
        case 'GoogleReviews':
            return isGarage || isCity ? (
                <GoogleReviews
                    reviewsData={garageData?.garage_review_ratings}
                    garage={garage}
                    reviewData={reviewData}
                />
            ) : null;
        case 'ImagesWithTitle':
            return (
                <ImagesWithTitle
                    heading={heading}
                    showAssuranceTag={showAssuranceTag}
                    imagesData={imagesUrl}
                />
            );
        case 'PremiumServices':
            return videos && videos.length > 1 ? (
                <GarageFeatureImageCarousel data={videos} />
            ) : null;
        case 'UserCard':
            return cardData && Object.keys(cardData).length ? (
                <UserCard cardData={cardData} />
            ) : null;
        case 'GarageCard':
            return pageType !== PAGE_TYPE.CITY_PAGE ? (
                <GarageCard
                    garageCardDetails={props.garageCardDetails}
                    garageCardHeading={garageCardHeadings.main}
                    buttonLabel={buttonLabels.selectCentre}
                    rewardTag={rewardTags.recommended}
                />
            ) : null;
        case 'Headings':
            return (
                <Headings
                    heading={replaceFieldsWithValues(
                        isBrand
                            ? brandheading
                            : isCity || isGarage
                              ? locationheading
                              : nearYouheading,
                        {
                            location: location,
                            brand: brand,
                            nearYou: 'near you',
                        }
                    )}
                    subText={replaceFieldsWithValues(
                        isBrand
                            ? brandSubText
                            : isCity || isGarage
                              ? locationSubText
                              : nearYouSubText,
                        {
                            location: location,
                            brand: brand,
                            nearYou: 'near you',
                        }
                    )}
                    logo={garageData?.servicing_brands?.find(
                        (servicing_brand?: any) => {
                            return (
                                brand?.toLocaleLowerCase() ===
                                servicing_brand?.company_name?.toLocaleLowerCase()
                            );
                        }
                    )}
                    isLandingPage={true}
                />
            );

        case 'LoginCard':
            return !isLoggedInServerSide ? (
                <LoginCard loginCardTitle={loginCardTitle} />
            ) : null;

        case 'PincodeCard':
            return garageId && isLoggedInServerSide ? (
                <PincodeCard
                    pincode={pincode || ''}
                    isloggedInServerSide={isLoggedInServerSide}
                />
            ) : null;

        default:
            return null;
    }
}
